import { AnimaliaSearchMapper, AnimaliaSearchPageDTO } from '../mappers/AnimaliaSearchMapper';
import { AnimaliaSearchRepositoryPort } from '../../domain/ports/AnimaliaSearchRepositoryPort';

export interface SearchAnimaliaInput {
  readonly query: string;
  readonly detailReturnTo?: string | null;
}

export class SearchAnimaliaUseCase {
  constructor(private readonly repository: AnimaliaSearchRepositoryPort) {}

  async execute(input: SearchAnimaliaInput): Promise<AnimaliaSearchPageDTO> {
    const query = input.query.trim();

    if (query === '') {
      throw new Error('La busqueda necesita al menos un texto no vacio.');
    }

    const items = await this.repository.search(query);

    return AnimaliaSearchMapper.toPageDTO(query, items, input.detailReturnTo ?? null);
  }
}
